import { useMutation, useQueryClient } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface UseCreateZendeskTicketProps {
  attachments: Array<{ zendeskUploadId: string }>;
  chatBotSessionId: string;
  onError: (error: any) => void;
  onSuccess: (ticket: any) => void;
  source: string;
}

interface CreateZendeskTicketParams {
  conversationId: string;
  priority: string;
  text: string;
  type: string;
}

export const useCreateZendeskTicket = ({
  onSuccess,
  onError,
  attachments,
  source,
  chatBotSessionId,
}: UseCreateZendeskTicketProps) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      text,
      type,
      priority,
      conversationId,
    }: CreateZendeskTicketParams) =>
      reactQueryPost(internalApi.supportWidget.createZendeskTicket(), {
        conversation: {
          subject: text,
          text,
          type,
          priority,
          conversation_id: conversationId,
          zendesk_upload_ids: attachments.map(
            attachment => attachment.zendeskUploadId,
          ),
          submit_page_url: window.location.href,
        },
        source,
        chat_bot_session_id: chatBotSessionId,
        viewport_height: String(
          window.innerHeight || document.documentElement.clientHeight,
        ),
        viewport_width: String(
          window.innerWidth || document.documentElement.clientWidth,
        ),
      }),
    onSuccess: data => {
      if (queryClient.getQueryData(["conversations", "list"])) {
        queryClient.setQueryData<{ conversations: any[] }>(
          ["conversations_v2", "list"],
          oldConversations => ({
            conversations: [
              data.ticket,
              ...(oldConversations?.conversations || []),
            ],
          }),
        );
      }

      onSuccess(data.ticket);
    },
    onError: onError,
  });
};
